import Table from '../../shared/components/table/Table';
import { ProjectMilestone } from '../../../domain/projectMilestones/projectMilestone';
import { ViewDetails } from '../../shared/components/ViewDetails';

interface Props {
    data: ProjectMilestone[];
    onSortingChange?: (columnName: string, sortOrder: 'asc' | 'desc') => void;
    sortedBy?: string | null;
    ascending?: boolean | null;
}

export default function ProjectMilestoneTable({
    data: milestones,
    onSortingChange,
    sortedBy,
    ascending,
}: Props) {
    const triggerSortingChange = (columnName: string, sortOrder: 'asc' | 'desc') => {
        if (onSortingChange) onSortingChange(columnName, sortOrder);
    };

    return (
        <Table
            sortedBy={sortedBy}
            ascending={ascending}
            onSortingChange={triggerSortingChange}
            columns={[
                {
                    isSortable: true,
                    name: 'Name',
                    title: 'Nombre',
                },
                {
                    isSortable: true,
                    name: 'TypeProject',
                    title: 'Tipo de Proyecto',
                },
                { isSortable: true, name: 'Ordinality', title: 'Ordinalidad' },
                { isSortable: false, name: 'Actions', title: '' },
            ]}
        >
            {milestones.map((milestone) => (
                <tr key={milestone.id}>
                    <td>{milestone.name}</td>
                    <td>{milestone.typeProject}</td>
                    <td>{milestone.ordinality}</td>
                    <td>
                        <ViewDetails
                            href={
                                '/project-milestone/update-project-milestone/' +
                                milestone.id
                            }
                        />
                    </td>
                </tr>
            ))}
        </Table>
    );
}
